import React from "react";
import { LinearProgress, Paper, Stack, Typography } from "@mui/material";

export default function OverviewCard({
  title,
  realizedValue,
  realizedPct,
  realizedPctNumber,
  planLabel,
  planValue,
  missingLabel,
  missingValue,
  of,
}) {
  function getColour() {
    if (realizedPctNumber >= 85) return "green";
    if (realizedPctNumber >= 75) return "orange";
    return "#123f52";
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.2,
        borderRadius: 3,
        background: "#f4f9fb",
        border: "1px solid #d6e8ef",
        height: "100%",
      }}
    >
      <Typography sx={{ fontWeight: 700, color: "#0d3342", mb: 1.25 }}>
        {title}
      </Typography>
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: getColour() }}>
          {realizedPct}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={Math.max(0, Math.min(100, realizedPctNumber || 0))}
        sx={{
          mt: 0.7,
          mb: 1,
          height: 8,
          borderRadius: 999,
          backgroundColor: "#d8eaf1",
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            background:
              "linear-gradient(90deg, rgb(16, 81, 106), rgb(14, 140, 192))",
          },
        }}
      />
      <Stack spacing={0.7}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" sx={{ color: "#4a6874" }}>
            {planLabel}
          </Typography>
          <Stack direction="row" alignItems="baseline" spacing={0.4}>
            <Typography
              variant="body2"
              sx={{ color: "#0f3342", fontWeight: 700 }}
            >
              {realizedValue}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0f3342", fontWeight: 300 }}
            >
              {of}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0f3342", fontWeight: 700 }}
            >
              {planValue}
            </Typography>
          </Stack>
        </Stack>
        {missingLabel && (
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: "#4a6874" }}>
              {missingLabel}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0f3342", fontWeight: 700 }}
            >
              {missingValue}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}
